import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center p-4">
      <Card className="strata-card max-w-md w-full">
        <CardContent className="pt-8 pb-8 text-center">
          <div className="w-16 h-16 mx-auto bg-slate-mid rounded-full flex items-center justify-center mb-4">
            <X className="w-8 h-8 text-slate-400" />
          </div>
          <h2 className="font-display text-2xl text-white mb-2">Payment Cancelled</h2>
          <p className="text-slate-400 mb-6">
            Your payment was cancelled. No charges were made.
          </p>
          <div className="flex gap-3 justify-center">
            <Button 
              onClick={() => navigate('/dashboard')}
              variant="outline"
              className="strata-button-secondary"
            >
              Return to Dashboard
            </Button>
            <Button 
              onClick={() => navigate(-1)}
              className="strata-button-primary"
            >
              Try Again
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
